/**
 * "Show in ACES": the immersion sprint program ACES follows a course as.
 * Stored in `courses.aces_program`; absent means ACES does not follow the
 * course. The values are the migration's CHECK list and ACES's program names.
 */
export const ACES_PROGRAMS = ['RIS', 'Agents', 'Leads'] as const;

export type AcesProgram = (typeof ACES_PROGRAMS)[number];

export function isAcesProgram(value: unknown): value is AcesProgram {
  return typeof value === 'string' && (ACES_PROGRAMS as readonly string[]).includes(value);
}

/** One course on GET /api/export/followed-courses. */
export type FollowedCourse = {
  course_id: string;
  title: string;
  program: AcesProgram;
  /** The standup start date, YYYY-MM-DD; the date the setup page calls the start. */
  start_date?: string;
  /** The standup end date, YYYY-MM-DD. */
  standups_end_date?: string;
};

export type FollowedCoursesResponse = {
  courses: FollowedCourse[];
  generated_at: string;
};
